import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
const TeachingStaffCard = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const sessionId = localStorage.getItem("currentSessionId");

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/students/students/count-summary`, {
        params: { sessionId }
      })
      .then(res => setCount(res.data.teachingStaff))
      .catch(err => console.error("Teaching staff error:", err));
  }, []);

  return (
    <Link to="/staff-report?type=teacher" className="flex">
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-center justify-between min-h-[110px] w-full hover:shadow-md hover:scale-[1.02] transition cursor-pointer">
        
        <div>
          <p className="text-sm text-gray-500 font-medium">Teaching Staff</p>
          <h3 className="text-3xl font-bold text-purple-600 mt-1">
            {count === null ? "..." : count}
          </h3>
        </div>

        <div className="w-12 h-12 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xl">
          <i className="fas fa-chalkboard-teacher"></i>
        </div>

      </div>
    </Link>
  );
};

export default TeachingStaffCard;
